import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { PervalValidators } from '../../../../shared';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-informations-client-edit-mode',
  templateUrl: './informations-client-edit-mode.component.html',
  styleUrls: ['./informations-client-edit-mode.component.scss'],
})
export class InformationsClientEditModeComponent implements OnChanges {
  @Input() informationsClient!: Report.Customer;

  @Output() informationsClientChanged = new EventEmitter<Report.Customer>();

  informationsClientForm = new FormGroup({
    firstname: new FormControl(''),
    lastname: new FormControl(''),
    phone: new FormControl(''),
    email: new FormControl('', PervalValidators.email),
    address: new FormControl(''),
    postalCode: new FormControl(''),
    city: new FormControl(''),
  });

  private newInformationsClient!: Report.Customer;

  ngOnChanges(changes: SimpleChanges): void {
    const currentInformationsClient =
      changes['informationsClient'].currentValue;
    if (currentInformationsClient) {
      this.newInformationsClient = currentInformationsClient;
      this.setFormValues();
    }
  }

  lastnameChanged(event: Event) {
    this.newInformationsClient = {
      ...this.newInformationsClient,
      lastName: (event.target as HTMLInputElement).value,
    };

    this.informationsClientChanged.emit(this.newInformationsClient);
  }

  phoneChanged(event: Event) {
    this.newInformationsClient = {
      ...this.newInformationsClient,
      phone: (event.target as HTMLInputElement).value,
    };

    this.informationsClientChanged.emit(this.newInformationsClient);
  }

  firstnameChanged(event: Event) {
    this.newInformationsClient = {
      ...this.newInformationsClient,
      firstName: (event.target as HTMLInputElement).value,
    };

    this.informationsClientChanged.emit(this.newInformationsClient);
  }

  addressChanged(event: Event) {
    this.newInformationsClient = {
      ...this.newInformationsClient,
      address: (event.target as HTMLInputElement).value,
    };

    this.informationsClientChanged.emit(this.newInformationsClient);
  }

  emailChanged(event: Event) {
    this.newInformationsClient = {
      ...this.newInformationsClient,
      email: (event.target as HTMLInputElement).value,
    };

    this.informationsClientChanged.emit(this.newInformationsClient);
  }

  postalCodeChanged(event: Event) {
    this.newInformationsClient = {
      ...this.newInformationsClient,
      postalCode: (event.target as HTMLInputElement).value,
    };

    this.informationsClientChanged.emit(this.newInformationsClient);
  }

  cityChanged(event: Event) {
    this.newInformationsClient = {
      ...this.newInformationsClient,
      city: (event.target as HTMLInputElement).value,
    };

    this.informationsClientChanged.emit(this.newInformationsClient);
  }

  private setFormValues(): void {
    this.informationsClientForm.controls.lastname.setValue(
      this.informationsClient.lastName,
    );

    this.informationsClientForm.controls.phone.setValue(
      this.informationsClient.phone,
    );

    this.informationsClientForm.controls.firstname.setValue(
      this.informationsClient.firstName,
    );

    this.informationsClientForm.controls.email.setValue(
      this.informationsClient.email,
    );

    this.informationsClientForm.controls.address.setValue(
      this.informationsClient.address,
    );

    this.informationsClientForm.controls.postalCode.setValue(
      this.informationsClient.postalCode,
    );

    this.informationsClientForm.controls.city.setValue(
      this.informationsClient.city,
    );
  }
}
